import M from "../strings"
import { PAGES } from "./vars"
import * as ui from "../web/utils/ui";
import { getLoggedUser } from "../api/session";
import { resetMenu } from "../actions/menu";

export const MENU_ITEM_TYPES = {
    ROOT: "root",
    ITEM: "item",
    SEPARATOR: "separator",
};

export default [
    {
        id: PAGES.EVALUATIONS,
        type: MENU_ITEM_TYPES.ROOT,
        icon: "ballot",
        text: M("evaluations"),
        href: "/entities/survey?showSidebar=false",
    },
    {
        id: PAGES.RETAILERS,
        type: MENU_ITEM_TYPES.ROOT,
        icon: "storefront",
        text: M("retailers"),
        href: "/entities/store?showSidebar=false",
    },
    {
        id: PAGES.SETTINGS,
        type: MENU_ITEM_TYPES.ROOT,
        icon: "settings",
        text: M("settings"),
        href: "/settings",
        children: [
            {
                id: "user",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "supervisor_account",
                text: M("users"),
                href: "/entities/user?grid=users",
                // permissions: ["user:list"]
            },
            {
                id: "role",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "key",
                text: M("roles"),
                href: "/entities/role?grid=roles",
            },
            {
                type: MENU_ITEM_TYPES.SEPARATOR,
            },
            {
                id: "storeType",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "store",
                text: M("storeTypes"),
                href: "/entities/storeType",
                // permissions: ["user:list"]
            },
            {
                type: MENU_ITEM_TYPES.SEPARATOR,
            },
            {
                id: "macroarea",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "square",
                text: M("macroareas"),
                href: "/entities/macroarea",
            },
            {
                id: "area",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "key",
                text: M("areas"),
                href: "/entities/area",
            },
            {
                id: "category",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "category",
                text: M("categories"),
                href: "/entities/category",
            },
            {
                type: MENU_ITEM_TYPES.SEPARATOR,
            },
            {
                id: "questionTemplate",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "quiz",
                text: M("questionsCatalog"),
                href: "/entities/questionTemplate",
            },
            {
                id: "surveyTemplate",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "content_paste",
                text: M("surveyTemplates"),
                href: "/entities/surveyTemplate",
            },
            {
                type: MENU_ITEM_TYPES.SEPARATOR,
            },
            {
                id: "presentationConfiguration",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "slideshow",
                text: M("presentationsExport"),
                href: "/entities/presentationConfiguration",
            },
            {
                id: "trendConfiguration",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "assessment",
                text: M("trendsExport"),
                href: "/entities/trendConfiguration",
            },
        ],
    },
]

export function getSurveyTemplateMenu(id) {
    return {
        id: PAGES.SETTINGS,
        type: MENU_ITEM_TYPES.ROOT,
        icon: "settings",
        text: M("settings"),
        href: "/settings",
        backButton: {
            label: M("back"),
            icon: "arrow_back",
            action: () => {
                resetMenu({user: getLoggedUser()});
                ui.navigate("/entities/surveyTemplate");
            },
        },
        children: [
            {
                id: "surveyTemplate.header",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "content_paste",
                text: M("surveyTemplateCard"),
                href: `/entities/surveyTemplate/${id}/header`,
            },
            {
                id: "surveyTemplate.questions",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "quiz",
                text: M("questions"),
                href: `/entities/surveyTemplate/${id}/questions`,
            },
            {
                id: "surveyTemplate.weights",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "monitor_weight",
                text: M("weights"),
                href: `/entities/surveyTemplate/${id}/weights`,
            },
            {
                id: "surveyTemplate.stores",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "storefront",
                text: M("allowedStores"),
                href: `/entities/surveyTemplate/${id}/stores`,
            },
        ]
    }
}

export function getStoreMenu(id) {
    return {
        id: PAGES.RETAILERS,
        type: MENU_ITEM_TYPES.ROOT,
        icon: "storefront",
        text: M("retailers"),
        href: "/entities/store?showSidebar=false",
        backButton: {
            label: M("back"),
            icon: "arrow_back",
            action: () => {
                resetMenu({user: getLoggedUser()});
                ui.navigate("/entities/store?showSidebar=false");
            },
        },
        children: [
            {
                id: "store.header",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "quiz",
                text: M("baseInfo"),
                href: `/entities/store/${id}/header`,
            },
            /*{
                id: "store.categories",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "quiz",
                text: M("categories"),
                href: `/entities/store/${id}/categories`,
            },*/
            {
                id: "store.targets",
                type: MENU_ITEM_TYPES.ITEM,
                icon: "quiz",
                text: M("targets"),
                href: `/entities/store/${id}/targets`,
            },
        ]
    }
}